import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { projects } from '../mock';

export default function Work() {
  // Group adjacent non-full projects so multiple full-width ones render in order
  const groups = [];
  let pair = [];
  projects.forEach((p) => {
    if (p.full) {
      if (pair.length) { groups.push({ type: 'grid', items: pair }); pair = []; }
      groups.push({ type: 'full', item: p });
    } else {
      pair.push(p);
    }
  });
  if (pair.length) groups.push({ type: 'grid', items: pair });

  return (
    <section id="work" className="relative py-[50px]">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16">
          <p className="reveal font-hand text-[26px] md:text-[30px] mb-2" style={{ color: 'var(--terracotta-deep)' }}>
            selected work
          </p>
          <h2 className="reveal reveal-delay-1 font-display text-[34px] md:text-[48px] leading-tight italic" style={{ color: 'var(--ink)' }}>
            I move rectangles around <span className="not-italic" style={{ color: 'var(--sage)' }}>(professionally)</span>
          </h2>
        </div>

        <div className="space-y-6 md:space-y-8">
          {groups.map((g, gi) =>
            g.type === 'full' ? (
              <div key={`full-${gi}`} className="reveal">
                <ProjectCard p={g.item} large />
              </div>
            ) : (
              <div key={`grid-${gi}`} className="grid md:grid-cols-2 gap-6 md:gap-8">
                {g.items.map((p, i) => (
                  <div key={p.slug} className={`reveal reveal-delay-${(i % 3) + 1}`}>
                    <ProjectCard p={p} />
                  </div>
                ))}
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
}

function ProjectCard({ p, large = false }) {
  return (
    <Link to={`/case/${p.slug}`} className="block project-card group">
      <div
        className={`relative overflow-hidden rounded-[22px] shadow-warm`}
        style={{
          aspectRatio: large ? '16/8' : '4/3',
          background: p.gradient,
        }}
      >
        {p.cover && (
          <img
            src={p.cover}
            alt={p.title}
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
        )}
        {/* Soft painterly highlights */}
        {!p.cover && (
          <div className="absolute inset-0" style={{
            backgroundImage:
              'radial-gradient(circle at 25% 20%, rgba(255,255,255,0.22), transparent 40%), radial-gradient(circle at 80% 85%, rgba(0,0,0,0.22), transparent 55%)',
          }} />
        )}

        {/* Handwritten placeholder label */}
        {!p.cover && (
          <span
            className="absolute bottom-5 left-5 font-hand text-[18px] opacity-70"
            style={{ color: 'rgba(250,246,238,0.9)' }}
          >
            add cover image —
          </span>
        )}

        {/* Overlay */}
        <div
          className="overlay absolute inset-0 flex flex-col justify-between p-6 md:p-9"
          style={{
            background:
              'linear-gradient(180deg, rgba(42,31,20,0.42) 0%, rgba(42,31,20,0.10) 40%, rgba(42,31,20,0.10) 60%, rgba(42,31,20,0.62) 100%)',
          }}
        >
          <div className="flex flex-wrap gap-2">
            {p.tags.map((t) => (
              <span
                key={t}
                className="text-[11.5px] tracking-[0.12em] uppercase px-3 py-1 rounded-full"
                style={{ background: 'rgba(250,246,238,0.22)', color: '#FAF6EE', backdropFilter: 'blur(6px)' }}
              >
                {t}
              </span>
            ))}
          </div>
          <span
            className="inline-flex items-center gap-2 text-[13px] tracking-[0.12em] uppercase self-start"
            style={{ color: '#D4A853' }}
          >
            View Case Study <ArrowRight size={15} />
          </span>
        </div>
      </div>

      {/* Caption below */}
      <div className="mt-4 md:mt-5 flex items-baseline justify-between gap-4">
        <h4 className="font-display text-[20px] md:text-[24px]" style={{ color: 'var(--ink)' }}>
          {p.title}
        </h4>
        <p className="text-[12.5px] tracking-[0.14em] uppercase whitespace-nowrap" style={{ color: 'var(--ink-soft)' }}>
          {p.company} · {p.year}
        </p>
      </div>
    </Link>
  );
}
